/**
 * ThaliaChat Service
 *
 * Self-Registration: Dieser Service registriert sich automatisch beim Import.
 * Consent-Modus: OHNE Usercentrics-Consent (requiresConsent: false)
 *
 * Um den Service zu entfernen: Einfach den gesamten thalia-chat Ordner löschen
 * und den Import in services/index.js entfernen.
 */
import serviceRegistry from "../ServiceRegistry";
import tuevInteg from "./data-integ";
import tuevProd from "./data-prod";

export { initAuthorizedBy };

function initAuthorizedBy(dps) {
	const { scriptSrc } = dps.serviceSettings;


	const script = document.createElement("script");
	script.src = scriptSrc;
	script.type = "text/javascript";
	script.async = 1;
	script.setAttribute('data-authorizedby-entry', "");
	document.getElementsByTagName("head")[0].appendChild(script);
}

// Self-Registration beim Modulstart
serviceRegistry.registerService({
	name: "authorized.by",
	initFunction: initAuthorizedBy,
	requiresConsent: true, // Service lädt ohne Consent
	configs: [tuevInteg, tuevProd]
});
